import styled from "styled-components";
import {ShowPasswordButtonDefaultBox} from "./show-password-button.default.box";

export const ShowPasswordButtonMrgreenBox = styled(ShowPasswordButtonDefaultBox)`
  color: ${({theme}) => theme.colors.text};
`